import { AuthBaseClient } from '../base-client';
import type { SubmitFeedbackRequest, SubmitFeedbackResponse } from './types';

/**
 * Client for the in-app "Send feedback" widget.
 * The endpoint accepts multipart/form-data because the widget allows
 * attachments (pasted screenshots, log files, etc.).
 */
export class FeedbackClient extends AuthBaseClient {
  async submit(
    payload: SubmitFeedbackRequest,
    attachments?: File[]
  ): Promise<SubmitFeedbackResponse> {
    const formData = new FormData();
    formData.append('subject', payload.subject);
    formData.append('message', payload.message);
    formData.append('url', payload.context.url);
    formData.append('userAgent', payload.context.userAgent);
    if (payload.context.viewport) {
      formData.append('viewport', payload.context.viewport);
    }
    formData.append('timestamp', payload.context.timestamp);

    if (attachments?.length) {
      for (const file of attachments) {
        formData.append('attachments', file);
      }
    }

    return this.uploadFormData<SubmitFeedbackResponse>('/api/feedback', formData);
  }
}
